<template>
  <div class="card1">
    <div class="card1-img"
         v-if="img">
      <img @click.prevent
           :src="img"
           width="100%">
    </div>
    <div class="card1-txts">
      <span class="card1-title"
            v-if="title"
            v-html="title"></span>
      <span class="card1-subTitle"
            v-if="subTitle"
            v-html="subTitle"></span>
      <p class="card1-txt"
         v-if="txt"
         v-html="txt"></p>
    </div>
  </div>
</template>

<script>

export default {
  name: '',
  props: {
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    txt: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  components: {},
  watch: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {}
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.card1 {
  &-img {
    font-size: 0;
  }
  &-txts {
    padding: px2rem(10) px2rem(15);
  }
  &-title {
    display: inline-block;
    margin: 0 px2rem(12) px2rem(12) 0;
    font-size: px2rem(15);
    color: #3c3c3c;
    font-weight: bold;
  }
  &-subTitle {
    display: inline-block;
    margin-top: px2rem(12);
    font-size: px2rem(12);
    color: #999999;
  }
  &-txt {
    font-size: px2rem(13);
    color: #666666;
    letter-spacing: 0;
    text-align: justify;
    line-height: px2rem(24);
  }
}
</style>
